// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ll-z","tupacHeader":"Ml-z","tupacHeader2":"Nl-z","tupacMenu":"Ol-z","tupacMenu2":"Pl-z","tupacMain":"Ql-z","tupacMain2":"Rl-z"};